import React from 'react';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import classnames from 'classnames';
import { DashboardMenuItem, getResources, Responsive, translate } from 'react-admin';
import { withStyles, createStyles } from '@material-ui/core/styles';

import LeftMenuGroup from './LeftMenuGroup';

const styles = createStyles({
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  }
});

type Props = {
  classes: any,
  hasDashboard?: boolean,
  logout: any,
  onMenuClick: any,
  open: boolean,
  pathname: string,
  resources: string[],
  translate: any
}

const LeftMenu = (props: Props) => (
  <div className={props.classes.main}>
    {props.hasDashboard && <DashboardMenuItem onClick={props.onMenuClick} />}

    <LeftMenuGroup group="Inventory" pathname={props.pathname} resources={props.resources} title="Inventory" translate={props.translate} />
    <LeftMenuGroup group="Campaign" pathname={props.pathname} resources={props.resources} title="Campaigns" translate={props.translate} />
    <LeftMenuGroup group="Configuration" pathname={props.pathname} resources={props.resources} title="Configurations" translate={props.translate} />
    <LeftMenuGroup group="Report" pathname={props.pathname} resources={props.resources} title="Reporting" translate={props.translate} />
    <LeftMenuGroup group="Admin" pathname={props.pathname} resources={props.resources} title="Administration" translate={props.translate} />
    <LeftMenuGroup group="Documentation" pathname={props.pathname} resources={props.resources} title="Documentation" translate={props.translate} />

    <Responsive xsmall={props.logout} medium={null} />
  </div>
);

const mapStateToProps = state => ({
  open: state.admin.ui.sidebarOpen,
  resources: getResources(state),
  pathname: state.router.location.pathname
});

const enhance = compose(
  translate,
  connect(mapStateToProps, {}, null, {
    areStatePropsEqual: (prev, next) =>
      prev.resources.every(
        (value, index) => value === next.resources[index]
      ) && prev.pathname === next.pathname && prev.open === next.open
  }),
  withStyles(styles)
);

export default enhance(LeftMenu);



// WEBPACK FOOTER //
// ./src/views/Framework/LeftMenu.tsx